import { CabinType, TripType } from "@website/tracking/types";

export const tripTypeMap: Record<string, TripType> = {
  oneway: TripType.one_way,
  roundtrip: TripType.roundtrip,
  unrecognized: TripType.UNRECOGNIZED
};

export const cabinTypeMap: Record<string, CabinType> = {
  economy: CabinType.economy,
  business: CabinType.business,
  first_class: CabinType.first_class,
  unrecognized: CabinType.UNRECOGNIZED,
  premium_economy: CabinType.premium_economy
};

export const normalizeCabinTypeKey = (value: string): CabinType => {
  if (!value) return CabinType.UNRECOGNIZED;

  const key = value.toLowerCase();
  return cabinTypeMap[key] ?? CabinType.UNRECOGNIZED;
};
